import { connect } from "react-redux";
import {
  receiveDatalistSearchPromisify,
  updateProspect
} from "../../../../../../store/actions/appConfig";
import { getOrgKYCDetails } from "../../../../../../store/selectors/appConfig";
import { CompanyBankingRelationshipsComponent } from "./CompanyBankingRelationships";

const mapStateToProps = state => ({
  orgKYCDetails: getOrgKYCDetails(state)
});

const mapDispatchToProps = {
  updateProspect,
  getDatalistSearch: receiveDatalistSearchPromisify
};

export const CompanyBankingRelationships = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyBankingRelationshipsComponent);
